import { render, staticRenderFns } from "./AreaConfirmPopup.vue?vue&type=template&id=0037eb7c&scoped=true&"
import script from "./AreaConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./AreaConfirmPopup.vue?vue&type=script&lang=js&"
import style0 from "./AreaConfirmPopup.vue?vue&type=style&index=0&id=0037eb7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0037eb7c",
  null
  
)

export default component.exports